import { render, staticRenderFns } from "./AppDaemonBadge.vue?vue&type=template&id=4e5b1dd0&scoped=true"
import script from "./AppDaemonBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDaemonBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppDaemonBadge.vue?vue&type=style&index=0&id=4e5b1dd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b1dd0",
  null
  
)

export default component.exports